import { render, staticRenderFns } from "./HTDetailsArea.vue?vue&type=template&id=63e391a4&scoped=true"
import script from "./HTDetailsArea.vue?vue&type=script&lang=js"
export * from "./HTDetailsArea.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=63e391a4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e391a4",
  null
  
)

export default component.exports